import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import configureStore from './store/configureStore';
import SignContainer from './container/sign/SignContainer';
import DashboardContainer from './container/dashboard';
import SignUpCompleteContainer from './container/sign/SignUpCompleteContainer';
import './App.css';
import './buttons.css';
import PrivateRoute from './component/common/PrivateRoute';
import ErrorBoundary from './component/common/ErrorBoundary';
import { appIsTabActive, appSetRedirectProductId } from './actions';
import { isAuthorized } from './util/session';
import SignQuoteContainer from './container/sign/SignQuoteContainer';

const history = createBrowserHistory();

const store = configureStore({}, history);

export class App extends Component {
  onWindowFocus = () => {
    store.dispatch(appIsTabActive(true));
  };

  onWindowBlur = () => {
    store.dispatch(appIsTabActive(false));
  };

  componentDidMount() {
    window.addEventListener('focus', this.onWindowFocus);
    window.addEventListener('blur', this.onWindowBlur);
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.onWindowFocus);
    window.removeEventListener('blur', this.onWindowBlur);
  }

  render() {
    return (
      <div className="importist-app">
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return isAuthorized() ? <Redirect to="/dashboard" /> : <Redirect to="/signin" />;
            }}
          />
          <Route exact path="/p1/:productId" component={SignQuoteContainer} />
          <Route exact path="/p2/:productId" component={SignQuoteContainer} />
          <Route
            exact
            path="/p/:productId"
            render={(props) => {
              store.dispatch(appSetRedirectProductId(props.match.params.productId));
              return <Redirect to="/signin" />;
            }}
          />
          <Route path="/signup-complete" component={SignUpCompleteContainer} />
          <Route path="/sign*" component={SignContainer} />
          <PrivateRoute path="/dashboard*" component={DashboardContainer} />
        </Switch>
      </div>
    );
  }
}

class AppContainer extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/App.js